import Api from '@/services/Api';

export default {
	async getAgents() {
		return await Api.get('/api/agents?order_by=first_name&order=asc&page=0');
	},
	async getAgentsSimple() {
		return await Api.get('/api/agents/simple');
	},
	async getAgent(id) {
		return await Api.get(`/api/agent/${id}`);
	},
	async updateAgent(agent) {
		if (agent.id) {
			return await Api.patch(`/api/agent/${agent.id}`, agent);
		}

		return await Api.post('/api/agent', agent);
	},
	async deleteAgent(id) {
		return await Api.delete('/api/agent', { data: { agent_id: id } });
	},
	async getDeletedAgents() {
		return await Api.get('/api/agents/deleted');
	},
	async restoreAgent(id) {
		return await Api.patch('/api/agent/restore', { agent_id: id });
	},
	async destroyAgent(id) {
		return await Api.delete('/api/agent/destroy', { data: { agent_id: id } });
	},
	async getSortedActiveAgents(obj) {
		return await Api.get(`/api/agents?order_by=${obj.order_by}&order=${obj.order}&page=${obj.page}`);
	},
	async getSortedDeletedAgents(obj) {
		return await Api.get(`/api/agents/deleted?order_by=${obj.order_by}&order=${obj.order}&page=${obj.page}`);
	}
};
